document.addEventListener('DOMContentLoaded', function () {
  class YgCardSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      const sectionId = this.getAttribute('data-section-id');
      const mobileSlides = parseFloat(this.getAttribute('data-mobile-slides')) || 1.2;
      const desktopSlides = parseInt(this.getAttribute('data-desktop-slides')) || 3;
      const mobileSpacing = parseInt(this.getAttribute('data-mobile-spacing')) || 12;
      const desktopSpacing = parseInt(this.getAttribute('data-desktop-spacing')) || 24;
      
      const initSwiperInstance = () => {
        if (typeof Swiper === 'undefined') return;
        
        const swiperElement = document.querySelector(`#yg-card-grid-${sectionId} .yg-card-swiper`);
        if (!swiperElement) return;

        this.swiperInstance = new Swiper(swiperElement, {
          slidesPerView: mobileSlides,
          spaceBetween: mobileSpacing,
          breakpoints: {
            1000: {
              slidesPerView: desktopSlides,
              spaceBetween: desktopSpacing
            }
          }
        });
      };

      if (typeof Swiper !== 'undefined') {
        initSwiperInstance();
      } else {
        window.addEventListener('load', initSwiperInstance);
      }
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }
  }

  if (!window.customElements.get('yg-card-swiper')) {
    window.customElements.define('yg-card-swiper', YgCardSwiper);
  }

  // YG Boxs Swiper Component
  class YgBoxsSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      const sectionId = this.getAttribute('data-section-id');
      const slidesPerView = parseInt(this.getAttribute('data-slides-per-view')) || 3;
      
      const initSwiperInstance = () => {
        if (typeof Swiper === 'undefined') return;
        
        // 仅在PC端初始化轮播
        if (window.innerWidth < 768) return;
        
        const swiperElement = document.querySelector(`#yg-boxs-swiper-${sectionId}`);
        if (!swiperElement) {
          console.error(`Swiper element not found: #yg-boxs-swiper-${sectionId}`);
          return;
        }

        this.swiperInstance = new Swiper(`#yg-boxs-swiper-${sectionId}`, {
          slidesPerView: 1.5,
          spaceBetween: 12,
          slidesPerGroup: 1,
          navigation: {
            nextEl: `#yg-boxs-swiper-${sectionId} .swiper-button-next`,
            prevEl: `#yg-boxs-swiper-${sectionId} .swiper-button-prev`,
          },
          breakpoints: {
            768: {
              slidesPerView: slidesPerView,
              spaceBetween: 12,
            },
            1024: {
              slidesPerView: slidesPerView,
              spaceBetween: 24,
            },
            1280: {
              slidesPerView: slidesPerView,
              spaceBetween: 24,
            }
          },
          on: {
            init: function() {
              console.log('YG Boxs Swiper initialized');
              console.log('Slides per view:', slidesPerView);
            }
          }
        });
      };

      if (typeof Swiper !== 'undefined') {
        initSwiperInstance();
      } else {
        window.addEventListener('load', initSwiperInstance);
      }
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }
  }

  if (!window.customElements.get('yg-boxs-swiper')) {
    window.customElements.define('yg-boxs-swiper', YgBoxsSwiper);
  }

  // YG Product Tab Component
  class YgProductTab extends HTMLElement {
    constructor() {
      super();
      this.swiperInstances = [];
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.initSwipers();
      this.initMainTabs();
      this.initSubTabs();
    }

    initSwipers() {
      const initSwiper = () => {
        if (typeof Swiper === 'undefined') return;
        
        const swiperElements = this.querySelectorAll('.product-subtabs .swiper');
        
        swiperElements.forEach(element => {
          if (element.swiper) {
            return;
          }
          
          const instance = new Swiper(element, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            freeMode: true,
            observer: true,
            observeParents: true
          });
          this.swiperInstances.push(instance);
        });
      };

      if (typeof Swiper !== 'undefined') {
        initSwiper();
      } else {
        window.addEventListener('load', initSwiper);
      }
    }

    initMainTabs() {
      const mainTabBtns = this.querySelectorAll('.main-tab-btn');
      const mainTabContents = this.querySelectorAll('.main-tab-content');
      const mainTabNav = this.querySelector('.main-tab-nav');
      const isMobile = window.innerWidth <= 999;

      mainTabBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const targetTab = btn.getAttribute('data-tab');
          const currentActiveContent = this.querySelector('.main-tab-content.active');
          const targetContent = this.querySelector(`#${targetTab}`);
          
          // 如果点击的是当前激活的tab，不执行切换
          if (currentActiveContent === targetContent) return;
          
          // Update button states
          mainTabBtns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          
          // 移动端保持激活的大tab贴齐左侧
          if (isMobile && mainTabNav) {
            this.scrollActiveMainTab(mainTabNav, btn);
          }
          
          // 使用 requestAnimationFrame 确保平滑过渡
          requestAnimationFrame(() => {
            // 先移除所有active状态
            mainTabContents.forEach(content => {
              content.classList.remove('active');
            });
            
            // 然后添加新的active状态
            if (targetContent) {
              targetContent.classList.add('active');
              
              // 延迟更新swiper，确保DOM已更新
              setTimeout(() => {
                this.updateSwipersInTab(targetContent);
              }, 50);
            }
          });
        });
      });
    }

    updateSwipersInTab(tabContent) {
      const swipers = tabContent.querySelectorAll('.swiper');
      swipers.forEach(swiperEl => {
        if (swiperEl.swiper) {
          setTimeout(() => {
            swiperEl.swiper.update();
          }, 100);
        }
      });
    }

    initSubTabs() {
      const subTabBtns = this.querySelectorAll('.product-subtab-btn');
      const isMobile = window.innerWidth <= 999;
      const transitionDuration = isMobile ? 250 : 300; // 移动端使用更短的过渡时间
      
      subTabBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const subtabIndex = btn.getAttribute('data-subtab');
          const parentContent = btn.closest('.main-tab-content');
          
          if (!parentContent) return;
          
          // Update sub-tab button states
          const siblingBtns = parentContent.querySelectorAll('.product-subtab-btn');
          siblingBtns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          
          // Switch image and product info simultaneously
          const images = parentContent.querySelectorAll('.tab-image-item');
          const infoItems = parentContent.querySelectorAll('.product-info-item');
          const currentActiveInfo = parentContent.querySelector('.product-info-item.active');
          const targetInfo = parentContent.querySelector(`.product-info-item[data-subtab-content="${subtabIndex}"]`);
          const targetImage = parentContent.querySelector(`.tab-image-item[data-subtab-image="${subtabIndex}"]`);
          
          // 如果点击的是当前激活的tab，不执行切换
          if (currentActiveInfo === targetInfo) return;
          
          // 同时切换图片和内容，使用requestAnimationFrame确保同步
          requestAnimationFrame(() => {
            // 移除所有active状态
            images.forEach(img => img.classList.remove('active'));
            infoItems.forEach(info => info.classList.remove('active'));
            
            // 添加新的active状态
            if (targetImage) {
              targetImage.classList.add('active');
            }
            if (targetInfo) {
              targetInfo.classList.add('active');
            }
          });
        });
      });
    }

    scrollActiveMainTab(nav, btn) {
      const navRect = nav.getBoundingClientRect();
      const btnRect = btn.getBoundingClientRect();
      const offsetLeft = btnRect.left - navRect.left + nav.scrollLeft;
      nav.scrollTo({
        left: offsetLeft,
        behavior: 'smooth'
      });
    }

    disconnectedCallback() {
      // Destroy all swiper instances
      this.swiperInstances.forEach(instance => {
        if (instance) {
          instance.destroy(true, true);
        }
      });
      this.swiperInstances = [];
    }
  }

  if (!window.customElements.get('yg-product-tab')) {
    window.customElements.define('yg-product-tab', YgProductTab);
  }
})